import { render, staticRenderFns } from "./MoveModal.vue?vue&type=template&id=312c0cf8&"
import script from "./MoveModal.vue?vue&type=script&lang=js&"
export * from "./MoveModal.vue?vue&type=script&lang=js&"
import style0 from "./MoveModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports